import Heading from '@algbra/ui/components/Heading/Heading'
import Icon from '@algbra/ui/components/Icon/Icon'
import { getIconByName } from '@algbra/ui/icons'
import styles from './SubbannerVideo.module.scss'

export type SubbannerVideoFullScreenProps = {
  youtube_code: string
  onToggleVideo: () => void
  isPlaylist: boolean
}
export function SubbannerVideoFullScreen({
  youtube_code,
  onToggleVideo,
  isPlaylist,
}: SubbannerVideoFullScreenProps) {
  const iframeSrc = isPlaylist
    ? `https://www.youtube.com/embed/?listType=playlist&list=${youtube_code}&autoplay=1&rel=0`
    : `https://www.youtube.com/embed/${youtube_code}?&autoplay=1&rel=0`
  return (
    <div className={styles.videoFixed}>
      <div className={styles.videoCloseBar}>
        <Icon
          icon={getIconByName('times')}
          className={styles.closeIcon}
          onClick={onToggleVideo}
        />
      </div>
      <iframe
        title="Algbra Decoded"
        style={{ border: 0 }}
        width="100%"
        height="100%"
        allow="autoplay; encrypted-media"
        src={iframeSrc}
        allowFullScreen
      ></iframe>
    </div>
  )
}
